import React from 'react';
import PropTypes from 'prop-types';
import { HorizontalFlex } from 'smartsuite-ui';
import { PadContainer } from 'smartsuite-ui/lib/containers/PadContainer';

export default function Legend({ legendItems }) {
    return (
        <HorizontalFlex cssClassModifiers={['justify-center', 'flex-wrap']}>
            {legendItems.map((item) => (
                <PadContainer
                    key={item.id}
                    cssClassModifiers={['pad-medium', 'no-pad-top-bottom']}
                >
                    <HorizontalFlex>
                        <span
                            style={{ backgroundColor: item.color }}
                            className="table-legend__indicator"
                        />
                        <PadContainer cssClassModifiers={['pad-medium']}>
                            {item.label}
                        </PadContainer>
                    </HorizontalFlex>
                </PadContainer>
            ))}
        </HorizontalFlex>
    );
}

Legend.propTypes = {
    legendItems: PropTypes.instanceOf(Array).isRequired,
};
